import {
    Autocomplete,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    Grid,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import User from "../backend/User";
import CourseData from "../backend/dataservices/CourseData";
import EmployeeData from "../backend/dataservices/EmployeeData";
import LastEditorEntry from "../backend/dataservices/LastEditorEntry";
import AttendanceData from "../backend/dataservices/AttendanceData";
import React from "react";
import TableUtils from "../utils/TableUtils";

function createCourseSuggestionsData(_name, _course) {
    return {name: _name, course: _course};
}

function createEmployeeSuggestionsData(_name, _employee) {
    return {name: _name, employee: _employee};
}

export default function CreateNewAttendanceDialogComponent(props) {

    const [dialogTextFieldValue, setDialogTextFieldValue] = React.useState('');
    const [dialogYearSelectValue, setDialogYearSelectValue] = React.useState('');
    const [dialogStatusSelectValue, setDialogStatusSelectValue] = React.useState('');
    const [dialogLoading, setDialogLoading] = React.useState(false);
    const [dialogSuggestions, setDialogSuggestions] = React.useState([]);
    const [dialogSuggestionValue, setDialogSuggestionValue] = React.useState(null);
    const [openDialogSuggestion, setOpenDialogSuggestion] = React.useState(false);
    const [dialogTypValue, setDialogTypValue] = React.useState('');

    React.useEffect(() => {
        setDialogTextFieldValue('');
        setDialogYearSelectValue('');
        setDialogStatusSelectValue('');
        setDialogTypValue('');
        setDialogSuggestionValue(null);
    }, []);

    function handleDialogYearChange(event) {
        setDialogYearSelectValue(event.target.value)
    }

    function handleDialogTypChange(event) {
        setDialogTypValue(event.target.value)
    }

    function createStateMenuItems() {
        let states = []

        if (User.getRole() === 'Verwalter') {
            states = [
                "Beantragt",
                "Warteliste",
                // "Inhouse",
            ]
        } else {
            states = [
                // "Geplant",
                "Beantragt",
                "Teilgenommen",
            ]
        }
        return states;
    }

    function handleDialogStatusChange(event) {
        setDialogStatusSelectValue(event.target.value);
    }

    function searchSuggestions(name) {
        setDialogLoading(true);
        if (props.searchCourses)
            CourseData.searchCourse(name).then(generateDialogRows);
        else
            EmployeeData.searchEmployeeByName(name).then(generateDialogRows)

    }

    async function loadDialogDataFromDatabase(rawData) {
        let tempRows = [];
        if(props.searchCourses) {
            for (const data of rawData) {
                tempRows.push(createCourseSuggestionsData(data.KS_Kursname, data));
            }
        } else {
            for (const data of rawData) {
                tempRows.push(createEmployeeSuggestionsData(data.M_Name + ", " + data.M_Vorname, data));
            }
        }
        return tempRows;
    }

    function generateDialogRows(rawData) {
        loadDialogDataFromDatabase(rawData).then(data => {
            setDialogSuggestions(data);
            setDialogLoading(false);
        });
    }

    function createYearMenuItems() {
        const years = []
        const MIN = new Date().getFullYear()
        const MAX = new Date().getFullYear() + 2

        for (let i = MAX; i >= MIN; i--) {
            years.push(i)
        }
        let components = [];

        years.forEach(function (year) {
            components.push({year: year});
        })
        return components;
    }

    function saveDialog() {
        let payload;
        if(props.knownCourseAndEmployee) {
            payload = {
                'KA_Pers-Nr': props.knownData.gid,
                KA_KursID: props.knownData.courseID,
                KA_Status: dialogStatusSelectValue,
                KA_Datum: new Date(parseInt(dialogYearSelectValue, 10), 11, 31).toISOString().slice(0, 19).replace('T', ' '),
                KA_Bearbeiter: LastEditorEntry.getLastEditorMessage(),
                KA_Typ: dialogTypValue
            }
        } else {
            payload = {
                'KA_Pers-Nr': props.searchCourses ? props.employeeData.gid : dialogSuggestionValue.employee['M_Pers-Nr'],
                KA_KursID: props.searchCourses ? dialogSuggestionValue.course.KS_ID : props.courseID,
                KA_Status: dialogStatusSelectValue,
                KA_Datum: new Date(parseInt(dialogYearSelectValue, 10), 11, 31).toISOString().slice(0, 19).replace('T', ' '),
                KA_Bearbeiter: LastEditorEntry.getLastEditorMessage(),
                KA_Typ: dialogTypValue
            }
        }
        AttendanceData.saveNewAttendance(payload).then(value => {
            props.handleSuccess();
        }, (error) => {
            props.handleError();
        });
    }

    let disabled;
    if(props.knownCourseAndEmployee) {
        disabled = dialogStatusSelectValue.length === 0 || dialogYearSelectValue.length === 0 || dialogTypValue.length === 0;
    } else {
        disabled = (dialogTextFieldValue == null || dialogTextFieldValue.length === 0) || dialogStatusSelectValue.length === 0 || dialogYearSelectValue.length === 0 || dialogTypValue.length === 0;
    }
    return(
        <Dialog open={props.openDialog}
                keepMounted
                onClose={props.handleClose}
                fullWidth>
            <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                Neue Kursanmeldung
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {props.knownCourseAndEmployee ?
                            <Grid item xs={12} marginTop={'5%'}>
                                {props.knownData.employeeName} für den Kurs {props.knownData.courseName} anmelden?
                            </Grid>
                            :
                            <Autocomplete options={dialogSuggestions}
                                          fullWidth
                                          size={"small"}
                                          open={openDialogSuggestion}
                                          onOpen={() => {
                                              setOpenDialogSuggestion(true)
                                          }}
                                          onClose={() => {
                                              setOpenDialogSuggestion(false)
                                          }}

                                          onInputChange={(event, newInputValue) => {
                                              if (newInputValue.length >= 2) {
                                                  searchSuggestions(newInputValue);
                                              }
                                          }}

                                          value={dialogSuggestionValue}
                                          onChange={(event, newInputValue) => {
                                              setDialogSuggestionValue(newInputValue);
                                              setDialogTextFieldValue(newInputValue);
                                          }}
                                          isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                                          getOptionLabel={(option) => option.name}
                                          renderOption={(props, option) => {
                                              return (
                                                  <li {...props}
                                                      key={option.course != null ? option.course.KS_ID : option.employee['M_Pers-Nr']}>
                                                      {option.name}
                                                  </li>
                                              );
                                          }}
                                          renderInput={(params => (
                                              <TextField
                                                  {...params}
                                                  size={"small"}
                                                  autoFocus
                                                  required
                                                  margin={"normal"}
                                                  label={props.searchCourses ? "Kursname" : "Mitarbeiter"}
                                                  type={"text"}
                                                  fullWidth
                                                  variant={"outlined"}
                                                  InputProps={{
                                                      ...params.InputProps,
                                                      endAdornment: (
                                                          <React.Fragment>
                                                              {dialogLoading ?
                                                                  <CircularProgress color={"primary"}/> : null}
                                                              {params.InputProps.endAdornment}
                                                          </React.Fragment>
                                                      ),
                                                  }}
                                              />
                                          ))}/>
                        }
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth size={"small"}>
                            <InputLabel>Jahr</InputLabel>
                            <Select
                                required
                                fullWidth
                                displayEmpty
                                label="Jahr"
                                value={dialogYearSelectValue}
                                onChange={handleDialogYearChange}
                                MenuProps={{style: {maxHeight: 200}}}>
                                {createYearMenuItems().map(function (year) {
                                    return <MenuItem key={year.year} value={year.year}>{year.year}</MenuItem>
                                })
                                }
                            </Select>
                            <FormHelperText>Kurs auf folgendes Jahr planen</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth size={"small"}>
                            <InputLabel>Status</InputLabel>
                            <Select
                                required
                                fullWidth
                                displayEmpty
                                label={"Status"}
                                value={dialogStatusSelectValue}
                                onChange={handleDialogStatusChange}>
                                {createStateMenuItems().map(function (select) {
                                    return <MenuItem key={select} value={select}>{select}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth size={"small"}>
                            <InputLabel>Typ</InputLabel>
                            <Select
                                required
                                fullWidth
                                displayEmpty
                                label="Typ"
                                value={dialogTypValue}
                                onChange={handleDialogTypChange}
                                MenuProps={{style: {maxHeight: 200}}}>
                                {TableUtils.getTypes().map(function (typ) {
                                    return <MenuItem key={typ} value={typ}>{typ}</MenuItem>
                                })
                                }
                            </Select>
                            <FormHelperText>Typ des Kurses wählen</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}/>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose} style={{color: "gray"}}>Abbrechen</Button>
                <Button
                    disabled={disabled}
                    onClick={saveDialog}>Speichern</Button>
            </DialogActions>
        </Dialog>
    )

}
